import React from 'react';

import { COLORS } from 'Components/foundation';
import UIcon from 'Components/unit/UIcon/UIcon';

import styles from '../Item.styles';

interface CalendarSectionProps {
  formattedDates: { start: string; end: string };
}

const CalendarSection: React.FC<CalendarSectionProps> = ({ formattedDates }) => (
  <div style={styles.containerCalendar} data-test-id="calendar-section">
    <UIcon name="calendar" size={16} color={COLORS.GREY_DARK.DEFAULT} style={styles.iconFooter} />
    <>
      {formattedDates.start}
      <UIcon name="arrow-right" size={10} color={COLORS.GREY_DARK.DEFAULT} style={styles.iconArrow} />
      {formattedDates.end}
    </>
  </div>
);

export default CalendarSection;
